import React, { Component } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Row, Col, Button, Card, Input, Divider, Select, Anchor, message, Form } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import Image from 'react-image-resizer';
import moment from 'moment';
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

const style = {
    profileImage: {
        display: 'inline',
        margin: '0 auto',
        // marginLeft: '-25%',
        height: '100%',
        width: 'auto'
    },
    vehicleImage: {
        display: 'inline',
        margin: '0 auto',
        height: '100%',
        width: 'auto',
        borderRadius: '5%'
    },
};

class BookTripForm extends Component {

    state = {
        trip: {},
        seatsRequired: 1
    }

    componentDidMount() {
        const tripId = this.props.match.params.tripId;
        console.log("TripId: ", tripId);
        axios.get(`${API_HOST_URL}/api/trips/${tripId}/?expand=user`)
            .then(res => {
                this.setState({
                    trip: res.data
                })

                console.log("trip data: ", res.data);
            })
    }

    handleSeatsChange = value => {
        console.log(`selected ${value}`);
        this.setState({
            seatsRequired: value
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                message.warning('Kindly provide all the required information');
                return;
            }
            console.log("Book values: ", values)

            return axios.post(`${API_HOST_URL}/api/bookings/`, {
                seatsRequired: this.state.seatsRequired,
                bookingFee: 0.1 * this.state.seatsRequired * this.state.trip.pricePerSeat,
                costOfSeats: (this.state.seatsRequired * this.state.trip.pricePerSeat),
                totalTripCost: (this.state.seatsRequired * this.state.trip.pricePerSeat) + (0.1 * this.state.seatsRequired * this.state.trip.pricePerSeat),
                passengerMessage: values.passengerMessage,
                bookingStatus: "requested",
                trip: this.state.trip.id,
                passenger: this.props.loggedInUser.pk
            })
                .then(res => {
                    console.log(res)
                    message.success("Booked successfully.");
                    this.props.history.push('/booked-success')
                })
                .catch(error => {
                    message.error("Booking failed due to an error!");
                    console.log(error);
                });
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { trip, seatsRequired } = this.state;
        const Option = Select.Option
        const { TextArea } = Input;

        console.log(this.props)

        return (
            <div>
                {/* <MainHeader/> */}
                <Form onSubmit={this.handleFormSubmit}>
                    <Card>
                        <Row gutter={16}>
                            <Col md={{ span: 12, offset: 3 }}>
                                {/* <img src={userProfile} style={{height: '15%', width: '15%'}} alt="logo" /> */}
                                <div className="image-cropper">
                                    <Image
                                        src={(trip.user && trip.user.profilePhoto !== null) ? (trip.user && trip.user.profile.profilePhoto) : userProfileImageHolder}
                                        height={100}
                                        width={100}
                                        style={style.profileImage}
                                    />
                                </div>
                                <h1 style={{ fontWeight: "bold" }} className="GrayText">Book with {trip.user && trip.user.last_name}</h1>
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        <h2 style={{ color: '#0099ff' }}>
                                            {trip.originCity} to {trip.destinationCity}
                                        </h2>
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <h2 style={{ fontWeight: "bold" }} className="GrayText"><span>{trip.numberOfSeats}</span> seats left</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                            {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                        </h3>
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <h3 className="GrayText" style={{ fontWeight: "bold", color: '#009a4b' }} >
                                            <span>
                                                <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                            </span>

                                            &nbsp;per seat</h3>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={{ span: 4 }}>
                                        <h3 style={{ fontWeight: "bold" }} className="GrayText"><span id="icon_from"></span>Pickup</h3>
                                    </Col>
                                    <Col md={{ span: 16 }}>
                                        <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.originCity}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{ span: 4 }}>
                                        <h3 style={{ fontWeight: "bold" }} className="GrayText">Dropoff</h3>
                                    </Col>
                                    <Col md={{ span: 16 }}>
                                        <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.destinationCity}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{ span: 22 }}>
                                        <h3 style={{ fontWeight: "bold" }} className="GrayText"><span id="icon_from">Description:</span></h3>
                                        <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                            {trip.tripDescription}
                                        </h3>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row>
                                    <Col md={{ span: 8 }}>
                                        <Image
                                            src={(trip.user && trip.user.primary_vehicle.length > 0) && (API_HOST_URL + (trip.user && trip.user.primary_vehicle[0].vehiclePhoto))}
                                            height={100}
                                            width={150}
                                        // style={style.vehicleImage}
                                        />
                                    </Col>
                                    <Col md={{ span: 16 }}>
                                        <h4 style={{ fontWeight: "bold" }} className="GrayText"> {trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate}</h4>
                                        <h4 className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel}</h4>
                                        <h4 style={{ fontWeight: "normal" }} className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].color}</h4>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        <h3 className="GrayText">Seats Required</h3>
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <Form.Item>
                                            {getFieldDecorator('seatsRequired', {
                                                rules: [{ required: false, message: 'Please select the seats you want to book!' }],
                                            })(
                                                <Select defaultValue={1} onChange={this.handleSeatsChange}>
                                                    {
                                                        Array.from({ length: trip.numberOfSeats }, (v, i) => 1 + i).map(item =>
                                                            <Option key={item} value={item}>{item}</Option>
                                                        )
                                                    }
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row>
                                    <Col md={{ span: 24 }}>
                                        <h3 className="GrayText">Message to {trip.user && trip.user.last_name}</h3>
                                        <Form.Item>
                                            {getFieldDecorator('passengerMessage', {
                                                rules: [{ required: true, message: 'Please tell '+ (trip.user && trip.user.last_name) + ' about your trip!'}],
                                            })(
                                                <TextArea rows={4} style={{ backgroundColor: '#efefef' }} placeholder={'Tell ' + (trip.user && trip.user.last_name) + ' a little more about your trip'} />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row>
                                    <Col md={{ span: 24 }}>
                                        <h3 className="GrayText">Payment Details</h3>
                                        <Row gutter={16}>
                                            <Col md={{ span: 16 }}>
                                            <h4 className="GrayText">You will pay cash to the Driver. Don't pay the booking fee.</h4>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={{ span: 6 }}>
                                <Anchor style={{ paddingTop: '24px' }}>
                                    <Card>
                                        <h3 className="GrayText">Booking</h3>
                                        <h3 style={{ fontWeight: "bold", color: '#0099ff' }} className="GrayText">
                                            {trip.originCity} to {trip.destinationCity}
                                        </h3>
                                        <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                            {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                        </h3>
                                        <Divider />
                                        <Row>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "normal" }} className="GrayText">{seatsRequired} {seatsRequired > 1 ? 'Seats' : 'Seat'}</h3>
                                            </Col>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                                    <NumberFormat value={seatsRequired * trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                                </h3>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "normal" }} className="GrayText">Booking fee</h3>
                                            </Col>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                                    <NumberFormat value={0.1 * (seatsRequired * trip.pricePerSeat)} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                                </h3>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "bold" }} className="GrayText">Total</h3>
                                            </Col>
                                            <Col md={{ span: 12 }}>
                                                <h3 style={{ fontWeight: "bold" }} className="GrayText">
                                                    <NumberFormat value={(seatsRequired * trip.pricePerSeat) + (0.1 * seatsRequired * trip.pricePerSeat)} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                                </h3>
                                            </Col>
                                        </Row>
                                        <Divider />
                                        <Button htmlType="submit" size="large" type="primary" style={{ backgroundColor: "#ff3d00", width: "90%", borderWidth: "0px" }}>
                                            Book Now
                                    </Button>
                                    </Card>
                                </Anchor>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null,
        loggedInUser: state.currentUser
    }
}

const BookTrip = Form.create({name: 'book-trip-form'})(BookTripForm)
export default connect(mapStateToProps, null)(BookTrip);
